/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AgreementType;
(function (AgreementType) {
    AgreementType["Subscription"] = "Subscription";
    AgreementType["Longterm"] = "Longterm";
})(AgreementType || (AgreementType = {}));
export function AgreementTypeFromJSON(json) {
    return AgreementTypeFromJSONTyped(json, false);
}
export function AgreementTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AgreementTypeToJSON(value) {
    return value;
}
